/**
 * Provides JS for Recent News block
 */
class FeaturedSliderCta extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
  }

  onReady(document) {
    this.slickInit();
  }

  slickInit() {    
    $('.slider-cta .slider .slides').each(function(){
      var $slider = $(this);
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll:1,
        prevArrow: $('.prev-slide'),
        nextArrow: $('.next-slide'),
      });
    });
  }
    
}

DrupalBehavior.register('psh_theme.components', 'featured_slider_cta', FeaturedSliderCta);
